module.exports = __webpack_public_path__ + "static/media/fuel.ff89d91e.svg";